// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metric-container {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 105px;
  width: 125px;
  background: white;
  border-top-right-radius: 100px;
  z-index: 99;
}

.metric-data-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-left: 10px;
}
.metric-data-container .metric-icon {
  height: 30px;
  width: 30px;
  margin-top: 10px;
  color: var(--planeed-blue);
  margin-bottom: 10px;
}
.metric-data-container .number {
  font-size: 16px;
  font-weight: bold;
  color: var(--planeed-blue);
}
.metric-data-container .unit {
  font-size: 14px;
  color: var(--planeed-blue);
}
.metric-data-container .metric-text {
  font-size: 10px;
  color: var(--planeed-black);
  padding: 0;
  border: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
